import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Navigation, Pagination, Grid } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/grid';

import IconChevronRight from 'js/components/icon/Icon.chevron-right';
import IconChevronLeft from 'js/components/icon/Icon.chevron-left';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.25,
    },
  },
};

const slideVariants = {
  hidden: {
    x: 24,
    opacity: 0,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 120,
      damping: 14,
    },
  },
};

const SwiperGrid = ({ slides = [] }) => {
  const [hasAnimated, setHasAnimated] = useState(false);

  return (
    <div
      style={{
        overflowX: 'hidden',
        position: 'relative',
        left: '-20px',
        width: 'calc(100% + 40px)',
      }}
    >
      <motion.div
        variants={containerVariants}
        initial={hasAnimated ? 'visible' : 'hidden'}
        animate="visible"
        onAnimationComplete={() => setHasAnimated(true)}
      >
        <Swiper
          className="swiper--carousel swiper--grid"
          modules={[Grid, Navigation, Pagination]}
          spaceBetween={15}
          slidesPerView="auto"
          grid={{ rows: 2, fill: 'row' }}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }}
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <motion.div variants={slideVariants}>{slide}</motion.div>
            </SwiperSlide>
          ))}

          <div className="swiper-button-prev">
            <IconChevronLeft />
          </div>
          <div className="swiper-button-next">
            <IconChevronRight />
          </div>
        </Swiper>
      </motion.div>
    </div>
  );
};

export default SwiperGrid;
